var set = require('regenerate')(0x149, 0x673, 0xF77, 0xF79, 0xE0001);

set.addRange(0x17A3, 0x17A4).addRange(0x206A, 0x206F).addRange(0x2329, 0x232A);
module.exports = set;